import React, { FunctionComponent } from "react"
import { FormControl, Table } from "react-bootstrap"
import tableItemsAlias from "./TemplateManagementAddOrEditTemplateRoleListTableItems"
import PortalRoleAndAssignmentTypes from "../../types/portalRoleTypes/PortalRoleAndAssignmentTypes"
import RoleTemplatePortalRoleLnkHashTableTypes from "../../types/hashTableTypes/RoleTemplatePortalRoleLnkHashTableTypes"
import RoleTemplatePortalRoleLinkPermissionsBoiler from "../../utils/boilerPlates/templateBoilerplates/RoleTemplatePortalRoleLinkPermissionsBoiler"
import TemplateManagementTablePermissionControls from "../TemplateManagementTable/TemplateManagementTablePermissionControls/TemplateManagementTablePermissionControls"
import handleAddOrDropRoleInTemplate from "../../utils/HandleAddOrDropRoleInTemplate"
import PortalRoleTemplateBoilerplate from "../../utils/boilerPlates/templateBoilerplates/PortalRoleTemplateBoilerplate"
import RoleTemplateHashTableTypes from "../../types/hashTableTypes/RoleTemplateHashTableTypes"
import PortalRoleTemplateWithLnksTypes from "../../types/portalTemplateTypes/PortalRoleTemplateWithLnksTypes"
import ratmService from "../../utils/RATMService"
import ratmHash from "../../utils/RATMHash"
import "./TemplateManagementAddOrEditTemplateRoleList.css"

interface Props {
    templateToAddOrEdit: PortalRoleTemplateWithLnksTypes
}

const TemplateManagementAddOrEditTemplateRoleList: FunctionComponent<Props> = (props) => {

    const { templateToAddOrEdit } = props
    const { state, manageState } = ratmService
    const { lookupHashTableItem } = ratmHash
    const { rolesAndAssignments, addOrEditTemplateId } = state

    let template = PortalRoleTemplateBoilerplate
    const hashedTemplate: RoleTemplateHashTableTypes = lookupHashTableItem(state.addOrEditTemplateId, 1)
    if (hashedTemplate) {
        //@ts-ignore
        template = addOrEditTemplateId < 1 ? hashedTemplate[1].templateItem : hashedTemplate[1].templateItem.Template
    }

    const getCheckboxStatus = (raa: PortalRoleAndAssignmentTypes) => {
        const linkedFromHash: RoleTemplatePortalRoleLnkHashTableTypes = lookupHashTableItem(raa.Role.PortalRoleId, 2)
        const permissions = linkedFromHash ? linkedFromHash[2].permissions : { ...RoleTemplatePortalRoleLinkPermissionsBoiler }
        const disabled = permissions.dropRole || (!permissions.hasRole && !permissions.addRole)
        return {
            checked: (permissions.hasRole && !permissions.dropRole && !disabled) || permissions.addRole,
            disabled: disabled,
            add: permissions.addRole,
            drop: permissions.dropRole
        }
    }

    return (
        <div className="TemplateManagementAddOrEditTemplateRoleList">
            <Table id="f09f19a28e43d486ad808756a5c330" bordered>
                <thead>
                    <tr id="ad54de363d484b03a78660b8977066e8">
                        {tableItemsAlias.map((item, i) =>
                            <th
                                className={`${i === tableItemsAlias.length - 1 ? "d6420854092744e8a5ce111614852aa3" : "ae687df30a8641958a419f8fb80b9d44"}`}
                                key={i}
                                style={{ width: item.width, maxWidth: item.maxWidth }}
                            >
                                {item.title}
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {rolesAndAssignments.map((raa, i) => {
                        const status = getCheckboxStatus(raa)
                        const forbidden = !templateToAddOrEdit.Template.IsProtected && raa.Role.IsProtected
                        return (
                            <tr
                                key={i}
                                className={`${forbidden ? "TemplateManagementAddOrEditTemplateRoleListTRForbidden" : "TemplateManagementAddOrEditTemplateRoleListTRNotForbidden"} TemplateManagementAddOrEditTemplateRoleListTR${status.add ? "Add" : status.drop ? "Drop" : "Same"}`}
                            >
                                {tableItemsAlias.map((item, j) =>
                                    <td
                                        className={`${j === tableItemsAlias.length - 1 ? "e8f26aa8ea641afda5b2223aed6aa" : "cfe664441091a8e18578b63b96"}`}
                                        key={j}
                                        style={{width: item.width, maxWidth: item.maxWidth, cursor: `${!forbidden ? "pointer" : "not-allowed"}` }}
                                        onClick={() => {
                                            if ((j < tableItemsAlias.length - 1) && !forbidden) {
                                                handleAddOrDropRoleInTemplate(raa.Role)
                                                manageState([])
                                            }
                                        }}
                                    >
                                        <div className="TemplateManagementAddOrEditTemplateRoleListTDItem">
                                            {j === 0 &&
                                                <div className="TemplateManagementAddOrEditTemplateRoleListTDItemCheckbox">
                                                    <FormControl
                                                        checked={status.checked}
                                                        onChange={() => null}
                                                        type="checkbox"
                                                    />
                                                </div>
                                            }
                                            <p
                                                style={{ fontWeight: item.fw }}
                                            >
                                                {/*@ts-ignore*/}
                                                {!item.isCheckBox && raa.Role[item.key]}
                                            </p>
                                            {/*@ts-ignore*/}
                                            {item.isCheckBox && <div className={`f7d0c564b742b1b08d7cf22ea65b02 ${raa.Role[item.key] ? "f7d0c564b742b1b08d7cf22ea65b02Yes" : "f7d0c564b742b1b08d7cf22ea65b02No"}`}>
                                                {/*@ts-ignore*/}
                                                <span className="material-icons">{`${raa.Role[item.key] ? "done" : "close"}`}</span>
                                            </div>}
                                            {j === tableItemsAlias.length - 1 &&
                                                <TemplateManagementTablePermissionControls
                                                    role={raa.Role}
                                                />
                                            }
                                        </div>
                                    </td>
                                )}
                            </tr>
                        )
                    }
                    )}
                </tbody>
            </Table>
        </div>
    )
}

export default TemplateManagementAddOrEditTemplateRoleList